<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-title"><a id="page_1"></a><a id="page_2"></a><a id="page_3">P<span class="small-caps">ART</span> I</a></h2><a id="page_3">
<p class="page_break">
</p></a><p class="att-text"><a id="page_3"></a><a id="page_4">“We have to keep in mind at all times that we are not fighting for integration, nor are we fighting for separation. We are fighting for recognition as free humans in this society.”</a></p><a id="page_4">
<p class="att-right"><em class="italic">—Malcolm X</em></p>
<p class="att-text">“Those who make peaceful revolution impossible will make violent revolution inevitable.”</p>
<p class="att-right"><em class="italic">—John F. Kennedy</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Part01.vue?a3d7246a